import React from 'react'

export default function AddWatermark(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M30.3 8.8V32c0 1.8-1.5 3.2-3.2 3.2H5c-1.8 0-3.2-1.5-3.2-3.2V4C1.8 2.2 3.2.7 5 .7h17.2c.5 0 1.1.2 1.4.6l6.1 6c.3.4.6.9.6 1.5Z"
          opacity=".1"
        />
        <path
          fill="currentColor"
          d="M30.2 6.8 23.8.6c-.3-.4-.9-.6-1.4-.6h-18C2.6 0 1 1.5 1 3.4v29.2C1 34.5 2.6 36 4.4 36h23.1c1.9 0 3.4-1.5 3.4-3.3V8.5c.1-.7-.2-1.3-.7-1.7Zm-.4 24.9c0 1.7-1.4 3.2-3.1 3.2H5.3c-1.7 0-3.1-1.4-3.1-3.2V4.3c0-1.7 1.4-3.2 3.1-3.2h16.5c.5 0 1 .2 1.4.6l5.9 5.8c.4.4.7 1 .6 1.6v22.6h.1Z"
        />
        <path
          fill="currentColor"
          d="M19.1 11.491c0 .535-.1.963-.2 1.497-.2.535-.3.963-.5 1.497-.5 1.283-.9 2.567-1 3.957 0 1.069.2 2.245.7 3.208l-4.9-.107c.5-.963.8-2.032.8-3.208-.1-1.39-.4-2.78-.9-4.064-.1-.534-.3-1.069-.5-1.497-.1-.427-.1-.962-.1-1.39 0-1.176.3-2.245 1-3.1C14 7.533 14.9 7 15.8 7c1.9.107 3.3 2.032 3.3 4.491Zm7.5 14.222H5v-1.925c0-.855.7-1.603 1.5-1.603h18.6c.8 0 1.5.748 1.5 1.604v1.924Zm-2.7.427H7.6v2.46h16.3v-2.46Z"
        />
      </svg>
    </div>
  )
}
